import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { EplService, EPL_MOCK_SCENARIOS, EplMockScenario, isEplMockEnvironment } from '../_services/epl.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

const EPL_REDIRECT_COUNTDOWN_SECONDS = 5;

@Component({
    selector: 'app-epl-login',
    templateUrl: './epl-login.component.html',
    styleUrls: ['./epl-login.component.css'],
    imports: [MatProgressSpinner, MatButton, AsyncPipe]
})
export class EplLoginComponent implements OnInit, OnDestroy {
    readonly isDev = isEplMockEnvironment();
    readonly mockScenarios = EPL_MOCK_SCENARIOS;
    mocking = false;
    redirecting = false;
    countdown: number | null = null;

    private countdownTimer: ReturnType<typeof setInterval> | null = null;

    constructor(
        public authService: AuthService,
        private eplService: EplService
    ) {}

    ngOnInit() {
        if (this.isDev || this.authService.eplLoginError$.value) {
            return;
        }

        if (this.eplService.hasCollegeBoardAuthToken()) {
            this.completeCollegeBoardSignIn();
            return;
        }

        this.startCountdown();
    }

    ngOnDestroy() {
        this.clearCountdown();
    }

    beginEplRedirect(): void {
        if (this.redirecting) {
            return;
        }

        this.clearCountdown();
        this.countdown = null;
        this.redirecting = true;
        void this.eplService.proceedToCollegeBoardLogin();
    }

    retryAfterError(): void {
        this.redirecting = false;
        this.authService.eplLoginError$.next(null);

        if (this.eplService.hasCollegeBoardAuthToken()) {
            this.completeCollegeBoardSignIn();
            return;
        }

        this.startCountdown();
    }

    private completeCollegeBoardSignIn(): void {
        this.clearCountdown();
        this.countdown = null;
        this.redirecting = false;
        void this.eplService.proceedToCollegeBoardLogin();
    }

    async simulateEplLogin(scenario: EplMockScenario): Promise<void> {
        this.mocking = true;
        this.authService.eplLoginError$.next(null);
        await this.authService.logout(false);
        await this.eplService.mockLogin(scenario);
        this.mocking = false;
    }

    private startCountdown(): void {
        this.countdown = EPL_REDIRECT_COUNTDOWN_SECONDS;
        this.countdownTimer = setInterval(() => {
            if (this.countdown === null) {
                return;
            }

            if (this.countdown <= 1) {
                this.beginEplRedirect();
                return;
            }

            this.countdown--;
        }, 1000);
    }

    private clearCountdown(): void {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
        }
    }
}
